// AddModal
import React from 'react';
import Input from '../../../components/UI/Input/index';
import SelectMultiple from '../SelectMultiple';

const typeTemplates = [
    {
        value: "main-page-hero",
        text: "Главная страница — слайдер товаров"
    },
    {
        value: "main-page-products",
        text: "Главная страница — товары"
    },
    {
        value: "office-hero",
        text: "Офис — главный слайдер"
    },
    {
        value: "office-products",
        text: "Офис — подборка товаров"
    },
    {
        value: "city-hero",
        text: "Город / администрации"
    },
];

const AddModal = ({
    formFeaturedProduct,
    currentId,
    setFormFeaturedProduct,
    products,
    productIds,
    setSelectedProduct,
    setProductIds,
    selectedProduct
}) => {
    const handleChange = (field, value) => {
        setFormFeaturedProduct({
            ...formFeaturedProduct,
            [field]: value
        });
    };

    const handleTypeTemplateChange = (e) => {
        const value = e.target.value;

        if (!value) {
            return;
        }

        handleChange("type", value);
    };

    return (
        <div className="featuredProductForm">
            <Input
                label="Название"
                value={formFeaturedProduct.name}
                placeholder="Название"
                onChange={(e) => handleChange("name", e.target.value)}
            />

            <div className="featuredProductForm__field">
                <label>Область списка</label>

                <select
                    value={formFeaturedProduct.scope}
                    onChange={(e) => setFormFeaturedProduct({
                        ...formFeaturedProduct,
                        scope: e.target.value,
                        officeId: e.target.value === "site" ? "" : formFeaturedProduct.officeId
                    })}
                >
                    <option value="site">Сайт</option>
                    <option value="office">Офис</option>
                </select>
            </div>

            <div className="featuredProductForm__field">
                <label>Быстрый выбор типа</label>

                <select
                    value=""
                    onChange={handleTypeTemplateChange}
                >
                    <option value="">Выбрать шаблон типа</option>

                    {typeTemplates.map((item) => (
                        <option
                            key={item.value}
                            value={item.value}
                        >
                            {item.text} / {item.value}
                        </option>
                    ))}
                </select>
            </div>

            <Input
                label="Тип списка вручную"
                value={formFeaturedProduct.type}
                placeholder="Например: main-page-hero"
                onChange={(e) => handleChange("type", e.target.value)}
            />

            <div className="featuredProductForm__hint">
                Для блока слева на главной странице нужен тип:
                <strong> main-page-hero</strong>
            </div>

            {formFeaturedProduct.scope === "office" && (
                <Input
                    label="ID офиса"
                    value={formFeaturedProduct.officeId}
                    placeholder="officeId"
                    onChange={(e) => handleChange("officeId", e.target.value)}
                />
            )}

            <Input
                label="Описание"
                value={formFeaturedProduct.description}
                placeholder="Описание"
                onChange={(e) => handleChange("description", e.target.value)}
            />

            {!currentId && (
                <SelectMultiple
                    items={products}
                    productIds={productIds}
                    selectedProduct={selectedProduct}
                    setSelectedProduct={setSelectedProduct}
                    setProductIds={setProductIds}
                    topImg="35%"
                    rightImg="15%"
                />
            )}
        </div>
    );
};

export default AddModal;